import isEmpty from "lodash/isEmpty";

const COMPLETE_PROFILE_EMAIL_SENT_KEY_PREFIX =
  "wl_express_complete_profile_email_sent:";
const EXPRESS_PROFILE_COMPLETED_KEY_PREFIX = "wl_express_profile_completed:";

const getStorage = (): Storage | null => {
  if (typeof localStorage === "undefined") {
    return null;
  }
  return localStorage;
};

export const hasCompleteProfileEmailBeenSent = (userId: string): boolean => {
  if (isEmpty(userId)) {
    return false;
  }

  const storage = getStorage();
  if (!storage) {
    return false;
  }

  return (
    storage.getItem(`${COMPLETE_PROFILE_EMAIL_SENT_KEY_PREFIX}${userId}`) ===
    "true"
  );
};

export const markCompleteProfileEmailSent = (userId: string): void => {
  if (isEmpty(userId)) {
    return;
  }

  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.setItem(`${COMPLETE_PROFILE_EMAIL_SENT_KEY_PREFIX}${userId}`, "true");
};

export const hasExpressProfileBeenCompleted = (userId: string): boolean => {
  if (isEmpty(userId)) {
    return false;
  }

  const storage = getStorage();
  if (!storage) {
    return false;
  }

  return (
    storage.getItem(`${EXPRESS_PROFILE_COMPLETED_KEY_PREFIX}${userId}`) ===
    "true"
  );
};

export const markExpressProfileCompleted = (userId: string): void => {
  if (isEmpty(userId)) {
    return;
  }

  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.setItem(`${EXPRESS_PROFILE_COMPLETED_KEY_PREFIX}${userId}`, "true");
};
